import { jsx } from "react/jsx-runtime";
import AppsIcon from "@mui/icons-material/Apps";
import { validateTidalLicense } from "../../base/index.js";
function Apps(props) {
  return /* @__PURE__ */ jsx(
    AppsIcon,
    {
      "data-testid": "Apps",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Apps",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
Apps.tidalIconMeta = {
  categories: "people,persona",
  name: "Apps"
};
validateTidalLicense();
export {
  Apps
};
//# sourceMappingURL=Apps.js.map
